import React from 'react'
import styles from './Photos.module.css'
import exp from 'constants'
import { PhotosProjectGalleryInterface } from '../../../../../../../lib/types/photosProjectGallery';
import { urlFor } from '../../../../../../../lib/sanity.client';

export type PhotosProps = {
    photosPG: PhotosProjectGalleryInterface | null;
}

const Photos = (props: PhotosProps) => {
    return (
        <>
        {props.photosPG &&
            <div className={styles.container}>               
                {props.photosPG.images.map((image, index) => (
                    <div className={styles.normal} key={index}>
                        <img src={urlFor(image).url()} alt={`Photos ${index + 1}`} />
                    </div>
                ))}
            </div>
        }
        </>
    )
}

export default Photos
